import UserAccountResourceModel from '../../generated/types/model/resource/UserAccountResourceModel';

export default class UserAccountResourceViewModel extends UserAccountResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
